import BackgroundTaskLocalStorage from "../../BackgroundTasks/storage/BackgroundTaskLocalStorage";

const storage = new BackgroundTaskLocalStorage();

const generateThumbnailInternal = (propsProvider, thumbnailGenerator) => {
  const { videosActions, values } = propsProvider();
  videosActions.saveVideoInfo(values);
  videosActions.changeImageProcessingState(false);
  thumbnailGenerator();
};

function videosThumbnailUploader(propsProvider) {
  const onOpenVideoMediaModal = () => {
    const { entityId, videosActions, streamingManifests } = propsProvider();
    if (streamingManifests.length === 0) {
      videosActions.getStreamingInfo(entityId);
    }
  };

  const generateThumbnail = (sas) => {
    generateThumbnailInternal(propsProvider, () => {
      const { videosActions, entityId } = propsProvider();
      videosActions.updateImageThumbnail(sas, entityId);
    });
  };

  return {
    onOpenVideoMediaModal,
    generateThumbnail,
  };
}

export default videosThumbnailUploader;
